export const ROOMS = [
  'Living Room',
  'Bedroom',
  'Kitchen',
  'Bathroom',
  'Garage',
  'Attic',
  'Basement',
  'Office',
  'Dining Room',
  'Kids Room',
  'Guest Room',
  'Other'
];
